import React from "react";
import NodataPic from "../../assets/Icon/Nodata.png";
const Nodata = () => {
  return (
    <div className="row justify-content-center align-items-center">
      <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
        <img src={NodataPic} alt="" className="img-fluid Nodata" />
      </div>
    </div>
  );
};

export default Nodata;
